import React, { Component } from 'react';
import axios from 'axios'
import { Form, Segment, Button, Divider } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency, logDashboardAction } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import ViewLargeCustomers from './ViewLargeCustomers'
import { getProjectDropDown, getShirtTypeDownDown } from './LargeProjectUtils'
import Select from 'react-select';
import ViewLargeProjectCosts from './ViewLargeProjectCosts';
import LargeProjectsNav from './LargeProjectsNav'
import { SingleDatePicker } from 'react-dates';
import { getShirtTypes, getShirtTypesToDisplay } from './ApiUtils'

import createBrowserHistory from 'history/createBrowserHistory';
import ViewInHouseCosts from './ViewInHouseCosts';
const history = createBrowserHistory({ forceRefresh: true });

class EnterProjectInHouseCosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            description: '',
            shirtTypeChoices: [],
            projectChoices: [],
            loading: true,
            qty: '',
            cost: '',
            customerId: '',
            projectId: '',
            shirtTypeId: '',
            showProjectCosts: false
        }
    }

    componentDidMount() {
        console.log("inhpc2 ++++++++++ EnterProjectInHouseCosts componentDidMount");

        getShirtTypesToDisplay(this.setShirtTypeDropDown, "large_projects");

        logDashboardAction(this.props.user.email + " loaded EnterProjectInHouseCosts for "+this.props.projectId, this.props.user.email , null, "lrgprj_EnterProjectInHouseCosts");

    }


    setShirtTypeDropDown = (shirtTypes) => {
       // console.log("eihc1 +++++++:setShirtTypeDropDown");
       // console.log("eihc12:" + JSON.stringify(shirtTypes, null, 3));
        this.setState({
            loading: false,
            shirtTypeChoices: shirtTypes
        })

    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        // console.log("hx32 e.target.name:" + e.target.name);
        // console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    handleDropDownChanges = (value) => {
        // console.log("lst1 handleDropDownChanges");
        // console.log('lst12 You\'ve sss:', value);
        // console.log("lst13 category alone:" + value.category);
        // console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        // console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        // console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    resetFeilds = () => {
        this.setState({
            description: '',
            qty: '',
            cost: '',
            shirtTypeId: ''
        })
    }

    sendProjectCosts = () => {
        console.log("inhpc2 ++++++++:sendCustomer");
        console.log("inhpc21 :"+this.state.description)
        console.log("inhpc22 :"+this.props.projectId)
        console.log("inhpc23 :"+this.state.qty)
        console.log("inhpc24 :"+this.state.cost)
        console.log("inhpc25 :"+this.state.shirtTypeId)
        console.log("inhpc26 :"+this.props.user.email)

       if (this.props.projectId == '') {
            alert("No project Selected")
        } else if (this.state.qty == '') {
            alert("No qty Entered")
        } else if (this.state.cost == '') {
            alert("No cost Entered")
        } else if (this.state.shirtTypeId == '') {
            alert("No Items Person")
        } else if (this.props.user.email == '') {
            alert("No Entered By Provided")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            let temp = {
                apiKey: "adfadsfeee",
                description: this.state.description,
                projectId: this.props.projectId,
                qty: this.state.qty,
                amount: this.state.cost,
                enteredBy: this.props.user.email,
                shirtTypeId: this.state.shirtTypeId,
            }

            console.log("inhpc27 :"+JSON.stringify(temp,null,3));

            axios.post(pythonApiIp + 'addLargeProjectInHouseCosts', {
                apiKey: "dsadfasdf@asdf",
                description: this.state.description,
                projectId: this.props.projectId,
                qty: this.state.qty,
                amount: this.state.cost,
                enteredBy: this.props.user.email,
                shirtTypeId: this.state.shirtTypeId,

            })
                .then((response) => {

                    this.setState({ loading: false });

                    console.log("inhpc28:"+JSON.stringify(response.data,null,3));

                    if (response.data.result) {
                        console.log("inhpc29 true.. in house cost added");

                        

                        this.resetFeilds();

                        alert(response.data.message);
                       // history.push("/dashboard/viewLargeProject/" + this.state.projectId);
                    } else {
                        console.log("inhpc26 FAILED");
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {


        const shirtTypeDropdown = this.state.shirtTypeChoices.length > 0
            ? <Select
                name="form-field-name"
                value={this.state.shirtTypeId}
                options={this.state.shirtTypeChoices}
                onChange={this.handleDropDownChanges}
                searchable={true}
                clearable={false}
            />
            : ''


        //const projectCosts = this.state.showProjectCosts && this.state.projectId && !this.props.projectId
        // const projectCosts = this.props.projectId
        //     //? <ViewLargeProjectCosts projectId={this.props.projectId} projectCosts={this.state.projectCosts} />
        //     ? <ViewLargeProjectCosts projectId={this.props.projectId} projectCosts={this.props.projectCosts} user={this.props.user} />
        //     : ''
        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>

                {/* {projectCosts} */}


                <Divider>{'ENTER IN HOUSE LARGE PROJECT COST'}</Divider>


                <Form size='large' onSubmit={this.sendProjectCosts}>
                    <Segment stacked>

                        <label>Enter Qty</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Qty'
                            type='number'
                            name="qty"
                            value={this.state.qty}
                            onChange={this.handleTextInputChange}
                        />

                        <label>Enter Cost</label><br />
                        <label>{toCurrency(this.state.cost)}</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Cost'
                            type='number'
                            name="cost"
                            value={this.state.cost}
                            onChange={this.handleTextInputChange}
                        />

                        <br />
                        <label>Select Items</label>
                        {shirtTypeDropdown}

                        <label>Enter Description (not required) </label>
                        <Form.Input
                            fluid
                            icon='blind'
                            iconPosition='left'
                            placeholder='Description'
                            type='text'
                            name="description"
                            value={this.state.description}
                            onChange={this.handleTextInputChange}
                        />

                        {/* <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2> */}

                        <Button>SEND</Button>
                    </Segment>

                </Form>


                IN HOUSE COSTS TABLE:
                <ViewInHouseCosts user={this.props.user} projectId={this.props.projectId}/>

            </div>
        );
    }
}

export default EnterProjectInHouseCosts;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/EnterProjectInHouseCosts.js